import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { signalsData } from "Stores/signalsData";
import SignalPicker from "./SignalPicker";
import { domainOf } from "./signalMeta";

/** Your company first, then the rest in the server's order. */
export const profileOptions = profiles =>
  profiles
    .slice()
    .sort((a, b) => (b.isYourCompany ? 1 : 0) - (a.isYourCompany ? 1 : 0))
    .map(p => ({ value: p.id, label: p.name || domainOf(p.website) || "Untitled profile", hint: domainOf(p.website), tag: p.isYourCompany ? "Your company" : "" }));

/**
 * Which seller profile a signal or an agent reads for: "For: Adapt.io · Change". Change opens a searchable list of
 * the team's profiles. `value` null means the team's default, which is handed back through onChange once loaded.
 * One profile: just its name. None: a link to add one.
 */
const SellerProfileLine = ({ value, onChange, className = "" }) => {
  const data = signalsData.sellerProfiles;
  useEffect(() => {
    signalsData.fetchSellerProfiles();
  }, []);
  const profiles = (data && data.profiles) || [];
  const current = profiles.find(p => p.id === value) || profiles.find(p => p.id === (data && data.defaultId)) || profiles[0];
  useEffect(() => {
    if (current && current.id !== value) onChange(current.id);
  }, [current && current.id]); // eslint-disable-line

  if (!data) return null;
  if (!current) {
    return (
      <div className={`sg-sp ${className}`}>
        <Link className="sg-link sg-sp__add" to="/settings/seller-profiles/new">Add your seller profile</Link>
      </div>
    );
  }
  return (
    <div className={`sg-sp ${className}`}>
      <span className="sg-sp__for">For: <b>{current.name || domainOf(current.website) || "Untitled profile"}</b></span>
      {profiles.length > 1 && (
        <>
          <span className="sg-sp__dot" aria-hidden="true">·</span>
          <SignalPicker value={current.id} onChange={onChange} options={profileOptions(profiles)} searchable buttonLabel="Change" className="sg-pick--link" />
        </>
      )}
    </div>
  );
};

export default observer(SellerProfileLine);
